/*
  This allows you to get values out of recoil that are outside of React Components.
  Based on npm package recoil-nexus.

  TODO: Please document **why** are we not just using https://www.npmjs.com/package/recoil-nexus.
*/

import { RecoilValue, useRecoilCallback } from "recoil";
import { getNexusInstance } from "./nexus.private";

export const useManageRecoilNexus = (): void => {
  const nexus = getNexusInstance();
  nexus.get = useRecoilCallback<[atom: RecoilValue<any>], any>(
    ({ snapshot }) =>
      <T>(atom: RecoilValue<T>) => {
        return snapshot.getLoadable(atom).contents;
      },
    [],
  );
};

export const getMaybeRecoilValue = <T>(atom: RecoilValue<T>): T | undefined => {
  const nexus = getNexusInstance();
  if (!nexus.get) {
    return undefined;
  }
  return nexus.get(atom);
};

export const getRecoilValue = <T>(atom: RecoilValue<T>): T => {
  const nexus = getNexusInstance();
  if (!nexus.get) {
    throw new Error(
      "Attempted to access nexus.get from RecoilNexus but it is not available",
    );
  }
  return nexus.get(atom);
};
